import { culturalRelicsBase, newsBase, messageBase } from './ipConfig';
// 第三方地址
let ThirdBaseUrl = 'http://szzy.hnswb.net'
/************************************************* 文物  *************************************************************/
//  获取文物类别
// export const getAllCategoriesUrl = culturalRelicsBase +'/api/antique/agetype'
//  获取文物列表
// export const getAllTabulateUrl = culturalRelicsBase +'/api/antique/type'
export const getAllTabulateUrl = ThirdBaseUrl + '/api.php?a=down_data'
//  获取文物详情
export const getAllDetailsUrl = culturalRelicsBase + '/api/antique/detail'




/************************************************* 新闻  *************************************************************/
//  获取新闻列表 
export const getAllNewsUrl = newsBase + '/hnbwgcms/common/api/page'
//  获取新闻详情
export const getAllNewsdetailsUrl = newsBase + '/hnbwgcms/common/api/infoMap'
/************************************************* 意见反馈  *************************************************************/
//  获取留言板
export const getAllMessageUrl = newsBase + '/hnbwgcms/common/api/guestPage'
//  留言发布
export const getAllSubmitUrl = newsBase + '/hnbwgcms/common/api/createSubmit'

